import { Outlet } from "react-router-dom";
import { AppLayout } from "@etframework/ui.components";
import useIsMounted from "../hooks/useIsMounted";
import { IconLoading } from "../components/Loading/IconLoading";
import DueDatesAppheader from "./components/DueDatesAppHeader";

//Providers
import { WelcomeModal } from "./portals/WelcomeModal";

const SimpleLayout = () => {
  const isMounted = useIsMounted(true);

  if (!isMounted) return <IconLoading />;

  return (
    <AppLayout className="duedates-settings-layout">
      <AppLayout.Header>
        <DueDatesAppheader />
      </AppLayout.Header>

      <AppLayout.ContentRow>
        <Outlet />
      </AppLayout.ContentRow>
      <AppLayout.Portals>
        <WelcomeModal />
      </AppLayout.Portals>
    </AppLayout>
  );
};

export default SimpleLayout;
